'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _event = require('./event');

var _edit = require('./edit');

var _pen = require('./pen');

var _point = require('./point');

var _rect = require('./rect');

var _text = require('./text');

var _page = require('./page');

exports.default = {
  addEventListener: _event.addEventListener, removeEventListener: _event.removeEventListener, fireEvent: _event.fireEvent,
  disableEdit: _edit.disableEdit, enableEdit: _edit.enableEdit,
  disablePen: _pen.disablePen, enablePen: _pen.enablePen, setPen: _pen.setPen,
  disablePoint: _point.disablePoint, enablePoint: _point.enablePoint,
  disableRect: _rect.disableRect, enableRect: _rect.enableRect,
  disableText: _text.disableText, enableText: _text.enableText, setText: _text.setText,
  createPage: _page.createPage, renderPage: _page.renderPage
};